'use client';

import { useState, useEffect } from 'react';

import { usePathname } from 'src/routes/hooks';

import { useResponsive } from 'src/hooks/use-responsive';

import PlanUpgradePopover from 'src/components/cmui/plan-upgrade/PlanUpgradePopover';
import { usePlanUpgradePopover } from 'src/components/cmui/plan-upgrade/use-plan-upgrade-popover';

export type CheckPlanUpgradeProps = {
  user?: any;
  event?: string | null;
  checkPlanResult?: any;
  onClose?: (() => void) | null;
  description?: string | null;
};

/**
 * PlanUpgradeProvider에서만 사용하는 업그레이드 팝오버
 */
export function CheckPlanUpgrade({
  user,
  event = null,
  checkPlanResult = null,
  onClose = null,
  description = null,
}: CheckPlanUpgradeProps) {
  const isMobile = useResponsive('down', 'sm');
  const pathname = usePathname();
  const { anchorEl, handleOpen, handleClose, open } = usePlanUpgradePopover();
  const [type, setType] = useState({});

  const handleCloseWithCallback = () => {
    handleClose();
    onClose?.();
  };

  useEffect(() => {
    if (!user || !checkPlanResult) {
      return undefined;
    }

    const { result, isExpired, required, key } = checkPlanResult;

    if (!result) {
      return undefined;
    }

    const resultKey = `${result}-${isExpired}-${required}-${key || ''}-${pathname}`;

    let status = 'expired';
    let isEvent = false;
    let isForceClosed = false;

    if (!isExpired) {
      status = 'upgrade';
    }

    if (event) {
      isEvent = true;

      if (event === 'custom') {
        isForceClosed = true;
      }
    }

    setType({
      status,
      isEvent,
      isMobile,
      isForceClosed,
      resultKey,
    });
    handleOpen(event);

    return undefined;
  }, [handleOpen, user, event, checkPlanResult, pathname, isMobile]);

  if (!checkPlanResult?.result) {
    return null;
  }

  return (
    <PlanUpgradePopover
      anchorEl={anchorEl}
      open={open}
      onClose={handleCloseWithCallback}
      type={type}
      checkPlanResult={checkPlanResult}
      description={description}
    />
  );
}
